// Google Formsの設定
export const FORM_CONFIGS = {
  FORM1: {
    ACTION_URL:
      'https://docs.google.com/forms/u/0/d/e/1FAIpQLSf2vsdnIvbhXdeTNhR5b-VXCZcdawEO7AMV2R0RbLofAnq4Yg/formResponse',
    ENTRIES: {
      REFERRER: 'entry.655647519',
      USER_AGENT: 'entry.1407386538',
      RESPONSE: 'entry.378088336',
    },
  },
  FORM2: {
    ACTION_URL:
      'https://docs.google.com/forms/u/0/d/e/1FAIpQLSeqXtrBLXz8Zj_rreOelUvJe2piv2FrYss9yd0NhsG-DCaOaw/formResponse',
    ENTRIES: {
      FEEDBACK: 'entry.1983684996',
    },
  },
};
